import { type ReactElement } from "react";

import { type ColumnCellProps } from "fixed-data-table-2";

export const columnCellRenderer =
    <T>(values: readonly T[], renderer: (props: ColumnCellProps & { value: T }) => ReactElement) =>
    (props: ColumnCellProps): ReactElement => {
        const value = values[props.rowIndex];
        if (!value) {
            throw new Error(`Missing column value with index: ${props.rowIndex}`);
        }
        return renderer({ ...props, value });
    };
